import BulbBook from "../Icons/BulbBook.icon";
import Devices from "../Icons/Devices.icon";
import React, { Component } from "react";
import Cogs from "../Icons/Cogs.icon";

const TAB_ICON_HEIGHT = 32;

export default class AboutTabs extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="shadow" style={{ background: "rgba(0, 0, 0, 0.5)" }}>
        <div className="row mx-0 justify-content-center">
          <div className="col-12 col-md-6 px-0 justify-content-center">
            <div className="d-flex text-center text-white justify-content-center flex-stretch">
              <a
                href="/how-it-works"
                className="text-decoration-none text-center text-white justify-content-center flex-stretch"
              >
                <div className="py-3 py-sm-2 px-sm-5 btn fill-white hover-fill-orange fill-white hover-fill-orange hover-bg-white hover-text-orange rounded-0 shadow-sm flex-column align-items-center">
                  <i className="d-none d-lg-inline ">
                    <Cogs
                      height={`${TAB_ICON_HEIGHT}px`}
                      width={`${TAB_ICON_HEIGHT}px`}
                    />
                  </i>
                  <h4 className="py-2 py-sm-0 pt-lg-2 ss-paragraph">
                    How it Works
                  </h4>
                </div>
              </a>

              <a
                href="/product-suite"
                className="text-decoration-none text-center text-white justify-content-center flex-stretch"
              >
                <div className="py-3 py-sm-2 px-sm-5 btn fill-white hover-fill-orange fill-white hover-fill-orange hover-bg-white hover-text-orange rounded-0 shadow-sm flex-column align-items-center">
                  <i className="d-none d-lg-inline ">
                    <Devices
                      height={`${TAB_ICON_HEIGHT}px`}
                      width={`${TAB_ICON_HEIGHT}px`}
                    />
                  </i>
                  <h4 className="py-2 py-sm-0 pt-lg-2 ss-paragraph">
                    Product Suite
                  </h4>
                </div>
              </a>

              <a
                href="/in-practice"
                className="text-decoration-none text-center text-white justify-content-center flex-stretch"
              >
                <div className="py-3 py-sm-2 px-sm-5 btn fill-white hover-fill-orange fill-white hover-fill-orange hover-bg-white hover-text-orange rounded-0 shadow-sm flex-column align-items-center">
                  <i className="d-none d-lg-inline ">
                    <BulbBook
                      height={`${TAB_ICON_HEIGHT}px`}
                      width={`${TAB_ICON_HEIGHT}px`}
                    />
                  </i>
                  <h4 className="py-2 py-sm-0 pt-lg-2 ss-paragraph">
                    In Practice
                  </h4>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/AboutTabs/index.js